<script setup lang="ts">
import { useProducts } from "@features/shopping/composables";
import { slugify } from "@shared/utils/slugify";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@ui/hover-card";
import { RouterLink } from "vue-router";

const { categories } = useProducts();
</script>

<template>
  <HoverCard :open-delay="0">
    <HoverCardTrigger as-child>
      <RouterLink
        to="/shop"
        class="hidden cursor-pointer items-center gap-1.5 text-content lg:flex"
      >
        <span>SHOP</span>
        <img src="@assets/images/common/arrow.svg" width="16" height="16" alt="Dropdown arrow" />
      </RouterLink>
    </HoverCardTrigger>
    <HoverCardContent :align="'start'" :align-offset="-20" :side-offset="15">
      <nav class="flex flex-col gap-4 text-label">
        <RouterLink
          v-for="category in categories"
          :key="category.product_cat_name"
          :to="`/product-category/${slugify(category.product_cat_name)}`"
        >
          {{ category.product_cat_name }}
        </RouterLink>
      </nav>
    </HoverCardContent>
  </HoverCard>
</template>
